export default __webpack_public_path__ + "static/media/dog.652b5096.mp3";